import { render, staticRenderFns } from "./StatusPin.vue?vue&type=template&id=2b280af8&scoped=true"
import script from "./StatusPin.vue?vue&type=script&lang=js"
export * from "./StatusPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b280af8",
  null
  
)

export default component.exports